import React, { useState } from 'react';

import { Typography /*Steps*/ } from 'antd';

import styled from 'styled-components';

import { useUserPermission } from '@contexts/UserContext';

// import { NwButton } from '@components/Gui/NwButton';
// import GeneralProjectInfoPanel from '@components/CreateProject/REMOVE_GeneralProjectInfoPanel';
// import ProjectTransactions from '@components/CreateProject/REMOVE_ProjectTransactions';
// import ProjectModels from '@components/CreateProject/REMOVE_ProjectModels';
import NwDrawer from '@components/Gui/NwDrawer';
import ProjectAddSelectForm from '@components/ProjectAddSelectForm/ProjectAddSelectForm';
import SystemMessage from '@components/Utils/SystemMessage';

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 16px;
    height: 30px;
`;

const CreateProjectDrawer = ({ onCloseModal, searchMode, searchOnly, showSecondLevel, drawerPlacement, onChange }) => {
    const [touchForm, setTouchForm] = useState(false);
    const handleSelectProject = (projectId) => {
        onChange(projectId);
        onCloseModal();
        if (touchForm) {
            setTouchForm(false);
        }
    };

    const canCreateEvent = useUserPermission('CreateBookingEvent');

    return (
        <NwDrawer
            touchForm={touchForm}
            onTouchForm={setTouchForm}
            placement={drawerPlacement}
            onClose={onCloseModal}
            title={
                <ModalHeader>
                    {!searchMode ? (
                        <>New Project</>
                    ) : (
                        <>
                            <Typography>Select Project</Typography>
                        </>
                    )}
                </ModalHeader>
            }
        >
            {!canCreateEvent ? (
                <SystemMessage type="not-allowed" />
            ) : (
                <ProjectAddSelectForm
                    drawerPlacement={drawerPlacement}
                    searchOnly={searchOnly}
                    showSecondLevel={showSecondLevel}
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    onSelectProject={handleSelectProject}
                    searchMode={searchMode}
                    onCancel={onCloseModal}
                />
            )}
        </NwDrawer>
    );
};

export default CreateProjectDrawer;
